import { OnboardingWizard } from "@/components/onboarding/OnboardingWizard";

const Onboarding = () => {
  return <OnboardingWizard />;
};

export default Onboarding;
